<template>
  <van-popup
    class="article-input"
    :value="value" @input="$emit('input',$event)"
    @closed="text=''"
    @opened="$refs.text.focus()"
    position="bottom"
  >
    <van-nav-bar
      left-arrow
      @click-left="$emit('input',false)"
      :title="title"
      right-text="发表"
      @click-right="$emit('submit', text)"
    ></van-nav-bar>
    <van-field
      ref="text"
      v-model="text"
      type="textarea"
      autosize
      :maxlength="100"
      :placeholder="placeholder"
    />
  </van-popup>
</template>
<script>
export default {
  name: 'ArticleInput',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      text: ''
    }
  }
}
</script>
<style scoped lang="less">
.article-input {
  width: 100%;
  height: 100%;
  /deep/ .van-nav-bar__right {
    .van-nav-bar__text {
      color: @ttColor;
    }
  }
  /deep/ .van-field {
    padding: 16px;
    .van-field__body {
      background: #F7F8FA;
      border-radius: 8px;
      padding: 5px 10px;
    }
  }
}
</style>
